import React, { useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import InputBox from "../../commonComponents/inputComponents/InputBox";
import "./resetPassword.css";

import { useAuth } from "../../../contexts/AuthContext";
import Loader from "../../commonComponents/Loader/Loader";

export default function ResetPassword() {
  const [isLoading, setIsLoading] = useState(false);
  const { changePassword } = useAuth();

  const currentPassRef = useRef();
  const newPassRef = useRef();
  const newPassConfRef = useRef();

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);

    const currentPassword = currentPassRef.current.value;
    const newPassword = newPassRef.current.value;
    const newPasswordConfirm = newPassConfRef.current.value;

    if (!currentPassword || !newPassword || !newPasswordConfirm) {
      setIsLoading(false);
      return toast.error("لطفا اطلاعات را وارد کنید");
    }

    if (newPassword !== newPasswordConfirm) {
      setIsLoading(false);
      return toast.error("رمز جدید با تایید آن همخوانی ندارد");
    }

    const data = {
      current_password: currentPassword,
      new_password: newPassword,
    };

    try {
      await changePassword(data);
    } catch (error) {
      setIsLoading(false);
      return toast.error(error);
    }

    setIsLoading(false);
    toast.success("تغییرات با موفقیت ذخیره شد");
  }

  return (
    <div className="password-reset-container">
      <form action="" onSubmit={handleSubmit}>
        <InputBox
          gap="0"
          width="30%"
          label="رمز عبور فعلی"
          type="password"
          ref={currentPassRef}
        />
        <InputBox
          gap="0"
          width="30%"
          label="رمز عبور جدید"
          type="password"
          ref={newPassRef}
        />
        <InputBox
          gap="0"
          width="30%"
          label="تکرار رمز عبور"
          type="password"
          ref={newPassConfRef}
        />
        <button
          className="red-submit-btn change-pass-submit"
          disabled={isLoading}
        >
          {isLoading ? <Loader loading={isLoading} small dark /> : "ویرایش"}
        </button>
      </form>
    </div>
  );
}
